<template>
    <div class="row">
        <div class="col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-primary" v-if="data.length > 0"
             v-for="(room, rowIndex) in data" :key="'row' + rowIndex">
            <app-hotel-room-preview-card
                :id="'room'"
                :room="room"
                :actions="actions"
                @action-room="triggerActions"
            />
        </div>
    </div>
</template>

<script>
export default {
    name   : "HotelRoomCardView",
    props  : {
        data   : {
            type    : Array,
            required: true
        },
        actions: {
            type: Array
        }
    },
    methods: {
        triggerActions(row, action, active) {
            this.$emit('getCardAction', row, action, active);
        }
    }
}
</script>
